document.addEventListener('DOMContentLoaded', function () {
  typePlaceholderLoop();
  window.swatch_slide_js();
  footer_wrap();
  //window.progress_gifts();
  window.adjustVariantWrapperWidth();
  video_playonscroll();
  maxheading_hight();
  //sava_data_storage();
  window.setMaxHeightQuickPrice();
  if(document.querySelector('.hide_coupan_all')){
    if(document.querySelector('.hide_coupan_all').value == 'true'){
      if(document.querySelector(".gift_product-wrap")){
      document.querySelector(".gift_product-wrap").style.display = 'none';
      }
    }else{
      if(document.querySelector(".gift_product-wrap")){
      document.querySelector(".gift_product-wrap").style.display = 'block';
      }
    }
  }

if (typeof window.updateBundleCards === "function") {
    window.updateBundleCards();
  }
// document.querySelectorAll('.pill-label').forEach(pill => {
//   const text = pill.textContent.trim();

//   // match number + "shades"
//   const match = text.match(/^(\d+\s+shades)/i);

//   if (match) {
//     pill.textContent = match[1] + "...";
//   }
// });

  const params = new URLSearchParams(window.location.search);

  if (params.get('open-cart') === 'true') {
    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }
  
   if(document.querySelectorAll('.freee_gift--wrapper > div')){
          let count = document.querySelectorAll('.freee_gift--wrapper > div').length;
        console.log("Total free gifts:", count);

        // Aap count ko HTML me print bhi kar sakte ho
      if(count != 0){
          let free_text = (count === 1) ? ' Freebie' : ' Freebies';
          document.querySelector(".count_gift").innerHTML = "/" + count + free_text;
        }
      }
  const cartTotal = cart.total_price / 100;
const discountEl = document.querySelector('.discount_message');
       // const free_shipping_text = document.querySelector('.free_text');
       const free_shipping_text = document.querySelector('.add_shipp_text');
        const giftEl = document.querySelector('.gift-unlock-text');
         if(document.querySelector('.shipping_bar_threshold')){
        const free_shipping = document.querySelector('.shipping_bar_threshold').getAttribute("data-freethreshold");
        if(parseInt(free_shipping) > cartTotal){
          if (free_shipping_text && giftEl) {
            giftEl.innerHTML = free_shipping_text.innerHTML;
          }
          if(document.querySelector(".cart_open")){
             document.querySelector(".cart_open").style.display = "none";
          }
          if(document.querySelector(".add_all")){
             document.querySelector(".add_all").style.display = "block";
          }
          
          if(document.querySelector("cart-drawer-items")){
           // document.querySelector("cart-drawer-items").classList.add("add_height");
           }
        }else{
          if (discountEl && giftEl) {
          giftEl.innerHTML = discountEl.innerHTML;
        }
         document.querySelector(".cart_open").style.display = "block";
         if(document.querySelector(".add_all")){
        document.querySelector(".add_all").style.display = "none";
         }
        //const cartItems = document.querySelector(".cart-drawer .drawer__cart-items-wrapper");
        // if (cartItems) cartItems.style.paddingTop = "5rem";
        setTimeout(() => {
        const bar = document.querySelector(".cart-drawer .shipping_bar_wrap");
           if (bar) bar.style.display = "none";
           if(document.querySelector("cart-drawer-items")){
            document.querySelector("cart-drawer-items").classList.remove("add_height");
           }
           
          //  const cartItems = document.querySelector(".cart-drawer .drawer__cart-items-wrapper");
          //  if (cartItems) cartItems.style.paddingTop = "0";
        }, 5000);
        }
      }
      //   if(document.querySelector('.shipping_bar_threshold')){
      //   const free_shipping = document.querySelector('.shipping_bar_threshold').getAttribute("data-freethreshold");
      //   if(parseInt(free_shipping) > cartTotal){
      //     if (free_shipping_text && giftEl) {
      //       giftEl.innerHTML = free_shipping_text.innerHTML;
      //     }
      //     const bar = document.querySelector("#MainContent .shipping_bar_wrap");
      //     if (bar) bar.style.display = "flex";
      //       document.querySelector(".cart_open").style.display = "none";
      //    document.querySelector(".add_all").style.display = "block";
      //   }else{
      //     if (discountEl && giftEl) {
      //     giftEl.innerHTML = discountEl.innerHTML;
      //   }
      //    document.querySelector(".cart_open").style.display = "block";
      //    document.querySelector(".add_all").style.display = "none";
      //   setTimeout(() => {
      //   //  const bar = document.querySelector("#MainContent .shipping_bar_wrap");
      //   //     if (bar) bar.style.display = "none";
      //     }, 5000);
      //   }
      // }
      /*** cart offer enable */
        // const progressEl = document.querySelector('.gift-total-progress');
        // const maxValue = progressEl?.max;
        // if(cartTotal > maxValue){
        //   document.querySelector('.cart_open').style.display = "block";
        //    document.querySelector('.add_all').style.display = "none";
        // }else{
        //   document.querySelector('.cart_open').style.display = "none";
        //    document.querySelector('.add_all').style.display = "block";
        // }
      /*** end cart offer enable */
 
  if (window.innerWidth >= 767) {
  move_desktop_slide_js();
  }
  // remove Mrp
  document.querySelectorAll('.price__sale').forEach(el => {
    el.innerHTML = el.innerHTML.replace(/MRP\s*/g, '');
  });

  const tabWrappers = document.querySelectorAll(".tab-title-wrap");

  tabWrappers.forEach(wrapper => {
    const tabs = wrapper.querySelectorAll(".tab-title");
    const section = wrapper.closest(".multi_col");
    if (!section) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        // Remove active from all tabs
        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");

        // Hide all tab contents of this section
        const contents = section.querySelectorAll(".featured-slider");
        contents.forEach(content => {
          content.style.display = "none";
          content.classList.remove("active");
        });

        // Show clicked tab content
        const activeContent = section.querySelector(`.tabcontent-${index + 1}`);
        if (activeContent) {
          activeContent.style.display = "block";
          activeContent.classList.add("active");

          // Re-run slider accessibility
          const activeSlider = activeContent.querySelector("slider-component");
          if (activeSlider && typeof activeSlider.setSlideVisibility === "function") {
            activeSlider.setSlideVisibility();
          }

          // Accessibility: Move focus to first focusable element inside
          const firstFocusable = activeContent.querySelector(
            'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          if (firstFocusable) {
            firstFocusable.focus();
          }
        }
        window.adjustVariantWrapperWidth();
        maxheading_hight();
      });
    });
  });


  const blogtabWrappers = document.querySelectorAll(".blog-title-wrap");

  blogtabWrappers.forEach(wrapper => {
    const tabs = wrapper.querySelectorAll(".tab-title");
    const section = wrapper.closest(".multi_col");
    if (!section) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        // Remove active from all tabs
        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");

        // Hide all tab contents of this section
        const contents = section.querySelectorAll(".featured-slider");
        contents.forEach(content => {
          content.style.display = "none";
          content.classList.remove("active");
        });

        // Show clicked tab content
        const activeContent = section.querySelector(`.tabcontent-${index + 1}`);
        if (activeContent) {
          activeContent.style.display = "grid";
          activeContent.classList.add("active");
          // Accessibility: Move focus to first focusable element inside
          const firstFocusable = activeContent.querySelector(
            'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          if (firstFocusable) {
            firstFocusable.focus();
          }
        }
        
      });
    });
  });


  const tabButtons = document.querySelectorAll('.tab-button');
  const tabPanels = document.querySelectorAll('.tab-panel');
  const contentWrapper = document.querySelector('.details-content-wrapper');
  const mainContentWrapper = document.querySelector('.account__details__wrap');
  const customerWrapper = document.querySelector('.customer');
  const backButton = document.querySelector('.back_button'); 
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('data-id');

      if (!targetId) return;

    // Remove active class from all buttons and panels
    tabButtons.forEach(btn => btn.classList.remove('active'));
    tabPanels.forEach(panel => panel.classList.remove('active'));

      tabButtons.forEach(btn => {
        const id = btn.getAttribute('data-id');
        if (id) contentWrapper.classList.remove(id);
        customerWrapper.classList.remove(id);
         mainContentWrapper.classList.remove('active');
      });

    // Add active state to clicked tab
    button.classList.add('active');
    const targetPanel = document.querySelector(`.tab-panel[data-target="${targetId}"]`);
    if (targetPanel) targetPanel.classList.add('active');

      contentWrapper.classList.add(targetId);
      mainContentWrapper.classList.add('active');
      customerWrapper.classList.add(targetId);
    });
  });
document.addEventListener('click', function(event) {
  if (event.target.classList.contains('order-button')) {
    document.querySelectorAll('.customer').forEach(function(element) {
      element.classList.remove('order--detail');
    });
  }
});

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('address-button')) {
    document.querySelectorAll('.customer').forEach(function(element) {
      element.classList.remove('address--detail');
    });
  }
});

// ✅ Back button — Reset everything
if (backButton) {
  backButton.addEventListener('click', () => {
    // Remove all active classes
    tabButtons.forEach(btn => btn.classList.remove('active'));
    tabPanels.forEach(panel => panel.classList.remove('active'));

    // Remove all dynamic state classes from wrappers
    tabButtons.forEach(btn => {
      const id = btn.getAttribute('data-id');
      if (id) contentWrapper.classList.remove(id);
      customerWrapper.classList.remove(id);
    });

    mainContentWrapper.classList.remove('active');
    customerWrapper.classList.remove('order--detail', 'address--detail');

    // Optionally, show default panel (if any)
    const defaultPanel = document.querySelector('.tab-panel[data-target="default"]');
    const defaultButton = document.querySelector('.tab-button[data-id="default"]');
    if (defaultPanel && defaultButton) {
      defaultPanel.classList.add('active');
      defaultButton.classList.add('active');
    }
  });
}

  // swatches chnage
  document.addEventListener('change', function (event) {
    const el = event.target;

    // Only handle variant radio buttons
    if (!el.matches('.variant-scroll-wrapper input[type="radio"]')) return;
console.log("DSfdsfdsf-sss");
    const mediaId = el.dataset.mediaId;
    const variantId = el.dataset.variantid;
    const cardWrapper = el.closest('.product-card-wrapper');
    const mediaWrapper = cardWrapper?.querySelector('.product-media-wrapper');
    const price = el.dataset.price; // Add this to each input
    const comparePrice = el.dataset.comparePrice; 
    const byob = el.closest(".byob-product-item");

    // Update hidden variant input
    const cardContent = el.closest(".card__content");
    if (cardContent) {
      const inputField = cardContent.querySelector(
        ".quick-add .card-price-wrap .product-variant-id, .quick-add .product-variant-id"
      );
      if (inputField) inputField.value = variantId;
    }
    if(byob){
      byob.querySelector(".add-product-box .add-box").setAttribute("data-variant_id", variantId);
    }

    // Update active class on pills
    const swatchWrapper = el.closest('.variant-scroll-wrapper');
    if (swatchWrapper) {
      swatchWrapper.querySelectorAll('.variant-pill').forEach(label => label.classList.remove('active'));
      el.closest('.variant-pill')?.classList.add('active');
    }

    // Update product price & compare-at price
  const priceWrapper = cardWrapper?.querySelector('.quick_price_wrap');
 console.log(priceWrapper,"--priceWrapper---",price,"--comparePrice--",comparePrice);
  if (priceWrapper && price) {
    const salePriceEl = priceWrapper.querySelector('.price__sale .price-item--sale');
    const regularPriceEl = priceWrapper.querySelector('.price__sale .price-item--regular');
     if(parseFloat(price) >= parseFloat(comparePrice) ){
      priceWrapper.querySelector('.price-item.price-item--regular.ts2').style.display ="none";
     }else{
      priceWrapper.querySelector('.price-item.price-item--regular.ts2').style.display ="flex";
     }
     if(comparePrice == 0){
      const salePrice = priceWrapper.querySelector('.sale-price-ts1');
      if (salePrice) {
       priceWrapper.querySelector('.sale-price-ts1').style.display ="none";
      }
       priceWrapper.querySelector('.price__sale').style.display ="none";
      priceWrapper.querySelector('.price__regular').style.display ="block";
      priceWrapper.querySelector('.price__regular .price-item--regular').textContent = `₹${price}`;
    }else{
      priceWrapper.querySelector('.price__regular').style.display ="none";
      priceWrapper.querySelector('.price__sale').style.display ="flex";
       if (salePriceEl) salePriceEl.textContent = `₹${price}`;
       if (regularPriceEl) regularPriceEl.textContent = comparePrice ? `₹${comparePrice}` : '';
    }
   
  }

    // Show/Hide images
    if (mediaWrapper && mediaId) {
      mediaWrapper.querySelectorAll('.product-media-item.variant_img').forEach(imgDiv => {
        if (imgDiv.dataset.mediaId === mediaId) {
          imgDiv.style.display = "block"; // show selected
          cardWrapper.querySelectorAll('.main-product-img').forEach(img => img.style.display = "none");
        } else {
          imgDiv.style.display = "none"; // hide others
        }
      });
    }
  });
  // search class body
  const searchBtn = document.querySelector(".mobile-search-wrap");

  if (searchBtn) {
    searchBtn.addEventListener("click", (e) => {
      e.preventDefault();
      document.body.classList.add("search-overflow");
    });
  }
  document.addEventListener("click", (e) => {
    if (e.target.closest(".search-modal__close-button, .modal__close-button")) {
      e.preventDefault();
      document.body.classList.remove("search-overflow");
      document
  .querySelectorAll(".search-modal__close-button, .modal__close-button")
  .forEach(btn => btn.click());
    }
  });
  document.querySelectorAll(".back_btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const closeBtn = document.querySelector(".search-modal__close-button.modal__close-button");
      if (closeBtn) {
        closeBtn.click();
      }
    });
  });

  document.querySelectorAll('details[id^="Details-HeaderSubMenu"]').forEach(details => {
    details.addEventListener("toggle", () => {
      if (details.open) {
        // Close all other open submenus
        document.querySelectorAll('details[id^="Details-HeaderSubMenu"]').forEach(other => {
          if (other !== details) {
            other.open = false;
            other.classList.remove("active");
          }
        });

        // Add active class to current
        details.classList.add("active");
      } else {
        // Remove active when closed
        details.classList.remove("active");
      }
    });
  });

  document.querySelectorAll("header-menu").forEach(menuEl => {
    const details = menuEl.querySelector("details");
    if (!details) return;

    let closeTimer;

    // Open on hover
    details.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
      details.setAttribute("open", "true");
      details.querySelector("summary").setAttribute("aria-expanded", "true");
    });

    // Close when leaving
    details.addEventListener("mouseleave", () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        details.removeAttribute("open");
        details.querySelector("summary").setAttribute("aria-expanded", "false");
      }, 200); // small delay for smoother UX
    });
  });
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".copy-btn"); // check parent button if SVG clicked
    if (btn) {
      const code = btn.getAttribute("data-code");
      navigator.clipboard.writeText(code).then(() => {
        btn.innerHTML = "✅"; // show checkmark
        setTimeout(() => {
          btn.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.6" y="1.6" width="10.4" height="10.4" rx="1.6" fill="#FBF4EF" stroke="#1A1A1A" stroke-width="1.12"/>
            <rect x="5.6" y="5.6" width="8.8" height="8.8" rx="1.2" fill="#FBF4EF" stroke="#1A1A1A" stroke-width="1.12"/>
          </svg>`;
        }, 1500);
      });
    }
  });


  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("swipe_on_mobile_dot")) {
      const el = e.target;
      const index = el.dataset.index;
      const wrapper = el.closest(".about_scroll-section");
      const slider = wrapper.querySelector(".about_srcoll--wrapper");
      const width = slider.querySelector(".si_wrap").offsetWidth;

      // remove active from all dots
      wrapper.querySelectorAll(".swipe_on_mobile_dot").forEach(dot => {
        dot.classList.remove("active");
      });

      // add active to clicked dot
      el.classList.add("active");

      // smooth scroll
      slider.scrollTo({
        left: width * index,
        behavior: "smooth"
      });
    }
  });
  // about-page-js
  try {
    const items = document.querySelectorAll(".text_si--main");
    const si_wrap = document.querySelectorAll(".si_wrap");
    const dotsContainer = document.querySelector(".swipe_on_mobile_dots");
    let currentIndex = 0;
    let startX = 0;
    let startY = 0;

    // Create dots based on data-dots attribute
    const dotsCount = parseInt(dotsContainer.getAttribute("data-dots"), 10);

    for (let i = 0; i < dotsCount; i++) {
      const dot = document.createElement("span");
      dot.classList.add("swipe_on_mobile_dot");
      dot.setAttribute("data-index", i); // store index

      if (i === 0) dot.classList.add("active");

      dot.addEventListener("click", (e) => {
        const index = parseInt(e.target.getAttribute("data-index"), 10);
        goToSlide(index);
      });

      dotsContainer.appendChild(dot);
    }

    const dots = document.querySelectorAll(".swipe_on_mobile_dot");

    function updateActive() {
      // Remove 'swiped' from all items first
      items.forEach((item) => item.classList.remove("active"));
      si_wrap.forEach((item) => item.classList.remove("active"));
      // Add 'swiped' only to current item
      items[currentIndex].classList.add("active");
      si_wrap[currentIndex].classList.add("active");

      // Remove 'active' from all dots first
      dots.forEach((dot) => dot.classList.remove("active"));
      // Add 'active' only to current dot
      dots[currentIndex].classList.add("active");

      // Slide effect
      document.querySelector(".slider").style.transform =
        `translateX(${-currentIndex * 230}px)`;
    }

    function goToSlide(index) {
      currentIndex = index;
      updateActive();
    }

    // Swipe detection for each item
    items.forEach((item) => {
      item.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      });

      item.addEventListener("touchend", (e) => {
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;

        const diffX = endX - startX;
        const diffY = endY - startY;

        // Horizontal swipe
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
          if (diffX > 0 && currentIndex > 0) {
            currentIndex--; // swipe right → previous
          } else if (diffX < 0 && currentIndex < items.length - 1) {
            currentIndex++; // swipe left → next
          }
          updateActive();
        }
      });
    });

    // Initialize
    updateActive();

    // about scroll section 
    const sections = document.querySelectorAll('.about_section');
    const img = document.getElementById('fixedImage');

    // preload + fade
    let currentSrc = null;
    function swapImage(src) {
      if (src === currentSrc) return;
      img.classList.add('hidden');
      const pre = new Image();
      pre.src = src;
      pre.onload = () => {
        img.src = src;
        currentSrc = src;
        requestAnimationFrame(() => img.classList.remove('hidden'));
      };
    }

    // init
    swapImage(sections[0].dataset.img);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const src = entry.target.dataset.img;
            swapImage(src);

          }
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach((s) => observer.observe(s));
    // about scroll section end


  } catch (error) {

  }
  // end about-page-js

  document.addEventListener("click", function (e) {
    const tab = e.target.closest(".tab_title");
    if (!tab) return;

    const targetId = tab.id; // e.g. "tab_title-3"
    const targetContent = document.querySelector(`.tab_content[data-target="${targetId}"]`);

    if (targetContent) {
      // Remove active class from all tabs and contents
      document.querySelectorAll(".tab_title").forEach(el => el.classList.remove("active"));
      document.querySelectorAll(".tab_content").forEach(el => el.classList.remove("active"));

      // Add active class to clicked tab and corresponding content
      tab.classList.add("active");
      targetContent.classList.add("active");

      // Smooth scroll to target content
      const headerOffset = 100; // adjust if you have a fixed header
      const elementPosition = targetContent.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  });

  // end dom
});

// variant width
window.adjustVariantWrapperWidth = () => {
  document.querySelectorAll('.product-card-wrapper').forEach(card => {
    const cardWidth = card.clientWidth - 35;
    const variantWrapper = card.querySelector('.custom-variant-fieldset');
    if (variantWrapper) {
      variantWrapper.style.width = cardWidth + 'px';
    }
  });
}
// On resize
window.addEventListener('resize', window.adjustVariantWrapperWidth);

function typePlaceholderLoop() {
  document.querySelectorAll('.search-effect').forEach(function(input) {
    input.setAttribute('placeholder', 'Search for Ayurvedic Lipstick');
  });
}
window.swatch_slide_js = () => {
  const sliders = document.querySelectorAll(".variant-scroll-wrapper");

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    // Desktop drag
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("dragging");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("dragging");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("dragging");
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return; // agar drag nahi hai toh ignore
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 0.5; // slow factor
      slider.scrollLeft = scrollLeft - walk;
    });

    // Touch swipe
    let touchStartX = 0;
    let touchScrollLeft = 0;
    let isTouching = false;

    slider.addEventListener("touchstart", (e) => {
      isTouching = true;
      touchStartX = e.touches[0].pageX - slider.offsetLeft;
      touchScrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("touchend", () => {
      isTouching = false;
    });

    slider.addEventListener("touchmove", (e) => {
      if (!isTouching) return;
      const x = e.touches[0].pageX - slider.offsetLeft;
      const walk = (x - touchStartX) * 0.5;
      slider.scrollLeft = touchScrollLeft - walk;
    });
  });
}
window.move_desktop_slide_js = () => {
  const sliders = document.querySelectorAll(".desktop-scroll-wrapper");

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    // Desktop drag
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("dragging");
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("dragging");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("dragging");
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX;
      const walk = (x - startX) * 0.8; // adjust speed
      slider.scrollLeft = scrollLeft - walk;
    });

    // Touch swipe
    let touchStartX = 0;
    let touchScrollLeft = 0;

    slider.addEventListener("touchstart", (e) => {
      touchStartX = e.touches[0].pageX;
      touchScrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("touchmove", (e) => {
      const x = e.touches[0].pageX;
      const walk = (x - touchStartX) * 0.8;
      slider.scrollLeft = touchScrollLeft - walk;
    });
  });
}
function footer_wrap() {
  const menuFooters = document.querySelectorAll('.footer-block--menu');
  const liquidFooters = document.querySelectorAll('.liquid_code_footer');

  // Create and group footer menus + liquid code together
  if (menuFooters.length > 0) {
    const wrapper = document.createElement('div');
    wrapper.className = 'second-footer-wrapper';

    const firstMenuFooter = menuFooters[0];
    firstMenuFooter.parentNode.insertBefore(wrapper, firstMenuFooter);

    // Move all menu footers inside wrapper
    menuFooters.forEach(menu => wrapper.appendChild(menu));

    // Move liquid_code_footer also inside same wrapper
    liquidFooters.forEach(footer => wrapper.appendChild(footer));
  }

  // Group newsletter + text footer separately
  const newsletter = document.querySelector('.newsletter_footer');
  const textFooter = document.querySelector('.text_footer');

  if (newsletter && textFooter) {
    const wrap1 = document.createElement('div');
    wrap1.className = 'first-footer-wrapper';
    newsletter.parentNode.insertBefore(wrap1, newsletter);
    wrap1.appendChild(newsletter);
    wrap1.appendChild(textFooter);
  }
}

document.addEventListener("click", function (event) {
  const el = event.target.closest(".add_fbt_item"); // handle clicks on .add_fbt_item or its children
  if (!el) return; // exit if click wasn't on the target element

  const id = el.getAttribute("data-id") || null;
  const data = [];

  if (id) {
    el.classList.add("loading-cls");
    data.push({
      id: id,
      quantity: 1,
      properties: null,
    });
    multipleATC(data, el);
  }
});

// cart offer js
let cartUpdating = false;

// const checkoutBtn = document.querySelector('.cart__checkout-button');

// function disableCheckout() {
//   checkoutBtn.disabled = true;
// }

// function enableCheckout() {
//   checkoutBtn.disabled = false;

// }


window.progress_gifts = async function() {
 // disableCheckout();
  cartUpdating = true;      // Cart update started
  console.log("testap");
  const offer1Raw = document.querySelector('.offer_1_variant')?.value;
  const offer2Raw = document.querySelector('.offer_2_variant')?.value;

  if (!offer1Raw && !offer2Raw) return;
   //document.querySelector('.cart__checkout-button').disabled = true;
  //   if(document.querySelector('.gokwik-checkout')){
  //  document.querySelector('.gokwik-checkout').classList.add('disabled-btn');
  //   }
  // Split by comma and convert to numbers
  const offer1Ids = offer1Raw ? offer1Raw.split(',').map(id => Number(id)) : [];
  const offer2Ids = offer2Raw ? offer2Raw.split(',').map(id => Number(id)) : [];

  const THRESHOLD_1 = 599;
  const THRESHOLD_2 = 799;
  const CART_URL = "/cart.js";

  try {
    const res = await fetch(CART_URL);
    const cart = await res.json();
    const total = cart.total_price / 100;
    const itemsInCart = cart.items.map(item => item.variant_id);

    //Check if any cart item has _build_box property
    const hasBuildBox = cart.items.some(item => item.properties && item.properties._build_box);

    // If _build_box found, stop further gift logic
    if (hasBuildBox) {
      console.log("Skipping freebie logic: Build Box found in cart.");
      return;
    }

    const freebiesToAdd = [];

    // Add freebies for threshold 1
    if (total >= THRESHOLD_1) {
      offer1Ids.forEach(id => {
        if (!itemsInCart.includes(id)) {
          freebiesToAdd.push({ id: id, quantity: 1, properties: { __freeproduct: "gift" } });
        }
      });
    }

    // Add freebies for threshold 2
    if (total >= THRESHOLD_2) {
      offer2Ids.forEach(id => {
        if (!itemsInCart.includes(id)) {
          freebiesToAdd.push({ id: id, quantity: 1, properties: { __freeproduct: "gift" } });
        }
      });
    }

    // Add freebies in a single request
    if (freebiesToAdd.length > 0) {
      multipleATC(freebiesToAdd);
    }

    // Remove freebies if total drops below thresholds
    const allFreebieIds = [...offer1Ids, ...offer2Ids];
    const removeFreebies = cart.items
      .filter(item => allFreebieIds.includes(item.variant_id))
      .map(item => item.variant_id)
      .filter(id =>
        (offer1Ids.includes(id) && total < THRESHOLD_1) ||
        (offer2Ids.includes(id) && total < THRESHOLD_2) ||
        total === 0
      );
      if(total == 0){
        window.refreshCart();
      }
  console.log(total,"--total === 0");
    if (removeFreebies.length && typeof window.removegiftitem === "function") {
      window.removegiftitem(removeFreebies, 0);
    }

  } catch (err) {
    console.error("Freebie logic failed:", err);
    cartUpdating = false;
  }
};

// end cart offer js
// remove gift code
window.removegiftitem = async (giftProductIds, qty = 0) => {
  console.log("Removing gift products:", giftProductIds);

  // Validate input
  if (!Array.isArray(giftProductIds) || giftProductIds.length === 0) {
    console.error("Invalid giftProductIds format");
    return;
  }

  // Build the updates object
  const updates = {};
  giftProductIds.forEach(id => {
    updates[id.toString()] = qty;
  });

  try {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });

    if (!res.ok) throw new Error("Network response was not ok");

    const data = await res.json();
    console.log("Removed products >>>>>>", data);

    // Refresh cart if function exists
    if (typeof window.refreshCart === "function") {
      window.refreshCart();
    
    }
  } catch (error) {

    console.error("Error removing gift products:", error);
  }
};

// end remove gift code
// Start: ATC button
function multipleATC(item_array, el = null) {
  this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  var items = [];

  item_array.forEach((item) => {
    let myObj = {
      id: item.id,
      quantity: item.quantity,
      properties: item.properties,
    };
    items.push(myObj);
  });

  let formData = {
    items: items,
  };


  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
//   fetch("/cart/add.js", {
//   method: "POST",
//   headers: {
//     "X-Requested-With": "XMLHttpRequest" 
//   },
//   body: formData  
// })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((items) => {
      // if (el) {
      //    el.removeClass("loading");
      // }
      setTimeout(() => {
      window.refreshCart();
      window.updateCartTotal();
      //window.progress_gifts();
      },0);


      console.log(items);
    })
    .catch((error) => {
      // console.error("Error:", error);
      // if (el) {
      //     el.removeClass("loading");
      // }
    });
}
window.refreshCart = () => {
    //  if(document.querySelector('.gokwik-checkout')){
    //  document.querySelector('.gokwik-checkout').classList.add('disabled-btn');
    //    }
  fetch('/cart?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      // console.log("html:", html);
      const count = parseInt(
        html.querySelector("cart-drawer-items")?.getAttribute("item_count") ||
          "0",
        10
      );
      // console.log("count:", count);
      const selectors = [
        ".drawer__inner",
        "cart-drawer-items",
        ".cart-drawer__footer"
      ];
      //document.querySelector(".cart__checkout-button.button").disabled = !1;
      const checkoutButton = document.querySelector(
        "button.cart__checkout-button"
      );
      
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        if (count > 0) {
          cartDrawer.classList.remove("is-empty");
          cartDrawer.classList.add("active");
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.remove("hidden");
          });
        } else {
          cartDrawer.classList.add("is-empty");
          document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
            bubble.classList.add("hidden");
          });
        }
      }
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
      }
      document
        .querySelectorAll(".cart-count-bubble span:first-child")
        .forEach((bubble) => {
          bubble.textContent = count;
        });
      const totalItemElement = document.querySelector(".ttl_item");
      if (totalItemElement) {
        totalItemElement.textContent = count;
      }
      //document.querySelector('.cart__checkout-button').disabled = false;
      setTimeout(function(){
       if(document.querySelector('.gokwik-checkout')){
      //document.querySelector('.gokwik-checkout').classList.remove('disabled-btn');
       }
      }, 5000);
      try {
      } catch (err) {
        console.error("Error updating widgets:", err);
      }
      window.move_desktop_slide_js();
    var view_product = JSON.parse(localStorage.getItem('viewed_products') || '[]');
    if (!view_product || view_product.length <= 1) return;

    var container = document.querySelector('.cart-review-upsell');
    var list = container.querySelector('.review-product-grid');
    if (!container || !list) return;

    container.style.display = 'block';

    Promise.all([
      fetch('/cart.js').then(res => res.json()),
      Promise.all(
        view_product.map(handle =>
          fetch(`/products/${handle}.js`).then(res => res.json())
        )
      )
    ]).then(([cart, products]) => {
      window.renderViewedProducts(products, list, cart);
    });
    })
    .catch((error) => {
      console.error("Error refreshing cart:", error);
    });
};
window.updateCartTotal = function () {
  if(document.querySelector('.hide_coupan_all')){
    if(document.querySelector('.hide_coupan_all').value == 'true'){
      if( document.querySelector(".gift_product-wrap")){
      document.querySelector(".gift_product-wrap").style.display = 'none';
      }
    }else{
      if(document.querySelector(".gift_product-wrap")){
      document.querySelector(".gift_product-wrap").style.display = 'block';
      }
    }
  }
  return fetch("/cart.js")
    .then(response => response.json())
    .then(cart => {
      const cartTotal = cart.total_price / 100; // Convert to ₹

      // Update a global variable
      window.cart_total = cartTotal;
      document.querySelectorAll(".shipping-progress").forEach(bar => {
        bar.value = cartTotal;
      });
      document.querySelectorAll(".gift-total-progress").forEach(bar => {
        bar.value = cartTotal;
      });
      document.querySelectorAll(".gift-total-progress").forEach(bar => {
        bar.value = cartTotal;
      });
      const cartValueEl = document.querySelector('.cart_value-wrap .cart_value');

        if (cartValueEl && typeof cartTotal !== 'undefined') {
          cartValueEl.textContent = `₹${cartTotal}`;
        }

        const discountEl = document.querySelector('.discount_message');
        const free_shipping_text = document.querySelector('.add_shipp_text');
        const giftEl = document.querySelector('.gift-unlock-text');
        if(document.querySelector('.shipping_bar_threshold')){
        const free_shipping = document.querySelector('.shipping_bar_threshold').getAttribute("data-freethreshold");
        if(parseInt(free_shipping) > cartTotal){
          if (free_shipping_text && giftEl) {
            giftEl.innerHTML = free_shipping_text.innerHTML;
          }
        }else{
          if (discountEl && giftEl) {
          giftEl.innerHTML = discountEl.innerHTML;
        }
        }
      }

      const progressEl = document.querySelector('.gift-total-progress');
      const maxValue = progressEl?.max;
      if(cartTotal > maxValue){
        document.querySelector('.cart_open').style.display = "block";
        if(document.querySelector('.add_all')){
         document.querySelector('.add_all').style.display = "none";
        }
      }else{
        document.querySelector('.cart_open').style.display = "none";
         if(document.querySelector('.add_all')){
         document.querySelector('.add_all').style.display = "block";
         }
      }
      
      const shippingBars = document.querySelectorAll(".shipping_bar_threshold");

    shippingBars.forEach((shippingBar) => {
      const shippingPrice = parseInt(shippingBar.dataset.freethreshold);
      const freeText = shippingBar.querySelector(".free_text");
      const addText = shippingBar.querySelector(".add_shipp_text");
      console.log(shippingPrice,"--shippingPrice--",window.cart_total);
        if (parseInt(window.cart_total) >= shippingPrice) {

          const cartItems = document.querySelector(".cart-drawer .drawer__cart-items-wrapper");
          // if (cartItems) cartItems.style.paddingTop = "5rem";
          if(document.querySelector("cart-drawer-items")){
            //document.querySelector("cart-drawer-items").classList.add("add_height");
           }
          freeText.style.display = "block";
            addText.style.display = "none";
          document.querySelectorAll(".cart_open").forEach(el => {
              el.style.display = "block";
            });

            document.querySelectorAll(".add_all").forEach(el => {
              el.style.display = "none";
            });
            

            setTimeout(() => {
              const bar = document.querySelector(".cart-drawer .shipping_bar_wrap");
              if (bar) bar.style.display = "none";
              if(document.querySelector("cart-drawer-items")){
            document.querySelector("cart-drawer-items").classList.remove("add_height");
           }
             // const cartItems = document.querySelector(".cart-drawer .drawer__cart-items-wrapper");
              //if (cartItems) cartItems.style.paddingTop = "0";
            }, 5000);
        }else{
          freeText.style.display = "none";
            addText.style.display = "block";
              document.querySelectorAll(".cart_open").forEach(el => {
              el.style.display = "none";
            });

            document.querySelectorAll(".add_all").forEach(el => {
              el.style.display = "block";
            });
           // const cartItems = document.querySelector(".cart-drawer .drawer__cart-items-wrapper");
          //  if (cartItems) cartItems.style.paddingTop = "5rem";
          if( document.querySelector("cart-drawer-items")){
         // document.querySelector("cart-drawer-items").classList.add("add_height");
          }
            console.log('addedddddddd>>>>>>>>>');
            //change when show free gift 
             const bar = document.querySelector(".cart-drawer .shipping_bar_wrap");
            //if (bar) bar.style.display = "flex";

        }

      if (parseInt(window.cart_total) >= shippingPrice) {
          console.log(shippingPrice,"--shippingPrice--2");
 
        setTimeout(() => {
          // const bar = document.querySelector("#MainContent .shipping_bar_wrap");
          // if (bar) bar.style.display = "none";
        }, 5000);
          // freeText.style.display = "block";
          // addText.style.display = "none";
      // } else {
      
        // freeText.style.display = "none";
        // const bar = document.querySelector("#MainContent .shipping_bar_wrap");
        // if (bar) bar.style.display = "flex";
        // addText.style.display = "block";

        // Update remaining amount dynamically
        const leftAmount = shippingPrice - parseInt(window.cart_total);
        const leftEl = shippingBar.querySelector(".left_amount");
        if (leftEl) leftEl.textContent = `₹${leftAmount}`;
      }

      // Optional: update progress bar inside this specific div
      const progress = shippingBar.querySelector("progress");
      if (progress) progress.value = Math.min(window.cart_total, shippingPrice);
    });
    //console.log(shippingPrice,"--shippingPrice--");

    
      // Also update any element in DOM if you want
      console.log(window.cart_total);
      if (cartTotal == 0) {
         const g_text = document.querySelector('.gift-text-main');
        const gift_wrap = document.querySelector('.gift-unlock-text');

        if (g_text && gift_wrap) {
          gift_wrap.innerHTML = g_text.innerHTML;
        }
      //  document.querySelector('.cart__checkout-button').style.display = 'none';
      }
      if(document.querySelectorAll('.freee_gift--wrapper > div')){
          let count = document.querySelectorAll('.freee_gift--wrapper > div').length;
        console.log("Total free gifts:", count);

        // Aap count ko HTML me print bhi kar sakte ho
       if(count != 0){
          let free_text = (count === 1) ? ' Freebie' : ' Freebies';
          document.querySelector(".count_gift").innerHTML = "/" + count + free_text;
        }
      }
      if(document.querySelector('cart-drawer-items')){
        const drawerItems = document.querySelector('cart-drawer-items');
        const discountMessage = document.querySelector('.discount_message');

        if(discountMessage){
        drawerItems.addEventListener('scroll', () => {
          if (drawerItems.scrollTop > 10) {
            discountMessage.classList.add('scroll-active');
          } else {
            discountMessage.classList.remove('scroll-active');
          }
        });
        }
     }

      // Get all threshold containers
      document.querySelectorAll(".shipping_bar_threshold").forEach(el => {
        const threshold = parseFloat(el.dataset.freethreshold);
        const left = Math.max(threshold - cartTotal, 0);

        const leftAmountEl = el.querySelector(".left_amount");
        if (leftAmountEl) {
          if (left > 0) {
            leftAmountEl.textContent = `₹${left} `;
          } else {
            leftAmountEl.textContent = "";
          }
        }
      });
      setTimeout(function(){
      if (typeof window.initFlashSaleTimer === "function") {
          window.initFlashSaleTimer();
        }
        }, 1000);
        window.fireKwikCartEvent();
       window.setMaxHeightQuickPrice();
      updateGiftProgress();
      return cartTotal;
    })
    .catch(err => console.error("Cart update failed:", err));
};
function updateGiftProgress() {
  const cartTotal = window.cart_total || 0;

  const giftItems = document.querySelectorAll('.gift_product-item, .freebie-offer-cart');
  giftItems.forEach((item, index) => {
    const progress = item.querySelector('progress');
    const threshold = parseFloat(item.dataset.threshold);

    if (!progress) return;

    // Update progress value
    if (index === 0) {
      progress.value = cartTotal;
    } else {
      const prevThreshold = parseFloat(giftItems[index - 1].dataset.threshold);
      progress.value = cartTotal > prevThreshold ? cartTotal : 0;
    }
    progress.max = threshold;

    // Add 'active' class if cart total >= threshold
    if (cartTotal >= threshold) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
}

// function equalizeCardHeights() {
//   const cards = document.querySelectorAll('.product-card-wrapper .prd_card-content');
//   let maxHeight = 0;

//   // Reset height first
//   cards.forEach(card => {
//     card.style.height = 'auto';
//   });

//   // Find the tallest card
//   cards.forEach(card => {
//     const height = card.offsetHeight;
//     if (height > maxHeight) {
//       maxHeight = height;
//     }
//   });

//   // Set all to the tallest height
//   cards.forEach(card => {
//     card.style.height = maxHeight + 'px';
//   });
// }
// window.addEventListener('load', equalizeCardHeights);
// window.addEventListener('resize', equalizeCardHeights);

window.addAddonProduct = async function (button) {
  try {
    // 🔹 Step 1: Get all reorder items inside the same order section
    const orderDetails = button.closest('.customer-order-details');
    const reorderItems = orderDetails.querySelectorAll('.reorder_data');

    // Collect all product IDs + quantities
    const addonProducts = Array.from(reorderItems)
      .map(item => ({
        id: item.getAttribute('id'),
        quantity: parseInt(item.dataset.quantity) || 1
      }))
      .filter(item => item.id);

    if (!addonProducts.length) {
      console.warn('No reorder_data items found');
      return;
    }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: addonProducts })
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Reorder products added:', result);
        if (window.refreshCart) window.refreshCart();
      } else {
        console.error('Failed to add reorder items:', response.statusText);
      }

  } catch (error) {
    console.error('Error adding reorder products:', error);
  }
};

// 🔹 Event listener for reorder button click
document.addEventListener('click', function (e) {
  const button = e.target.closest('.reorder_btn-btn');
  if (button) {
    window.addAddonProduct(button);
  }
});

function video_playonscroll() {
  const videos = document.querySelectorAll('.h-first-video video, .ayurveda-video video');

  if (videos.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play().catch(err => console.log('Video play error:', err));
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.5 }); // play when 50% visible

    videos.forEach(video => observer.observe(video));
  }
}

function maxheading_hight(){
   const cardInfos = document.querySelectorAll('.card__information');

  if (!cardInfos.length) return;

  // Group by container parent (if needed)
  const parentContainers = new Set();
  cardInfos.forEach(card => {
    parentContainers.add(card.closest('.grid') || card.parentElement);
  });

  parentContainers.forEach(container => {
    const headings = container.querySelectorAll('.card__information .card__heading');
    if (!headings.length) return;

    // Reset heights first
    headings.forEach(h => h.style.height = 'auto');

    // Find tallest heading
    let maxHeight = 0;
    headings.forEach(h => {
      const height = h.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    // Apply uniform height
    headings.forEach(h => h.style.height = `${maxHeight}px`);
  })
}
/*** wishlist-js */
// const WISHLIST_KEY = 'shopify_wishlist';

// const getWishlist = () => {
//   let list = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
//   return list.filter(h => h && h.trim() !== "");
// };

// const saveWishlist = (data) => {
//   if (data.length === 0) {
//     // 🔥 If empty → clear
//     localStorage.removeItem(WISHLIST_KEY);
//   } else {
//     localStorage.setItem(WISHLIST_KEY, JSON.stringify(data));
//   }
// };

// const updateWishlistIcons = () => {
//   const wishlist = getWishlist();

//   document.querySelectorAll('.wishlist-btn').forEach(btn => {
//     const handle = btn.dataset.handle;

//     if (!handle || handle.trim() === "") return; // stop invalid buttons

//     btn.classList.toggle("active", wishlist.includes(handle));
//   });
// };

// // CLICK HANDLER (Event Delegation)
// document.body.addEventListener('click', async (e) => {
  
//   // remove wishlist
//   const removeBtn = e.target.closest('.wishlist-remove');
//   if (removeBtn) {
//     console.log("removeBtn");
//     const handle = removeBtn.dataset.handle; 
//     const customerId = window.SHOPIFY_CUSTOMER_ID || null;
//     console.log(handle,"----handle");
//     if (!handle || handle.trim() === "") return;

//     let wishlist = getWishlist();
//     wishlist = wishlist.filter(h => h !== handle);
//     console.log(wishlist,"----wishlist");

//     // Optionally remove card from DOM
//     removeBtn.closest('.card-wrapper')?.parentElement?.remove();

//     updateWishlistIcons();
//     saveWishlist(wishlist);
//     save_data_db(wishlist,customerId);
//     document.querySelector(".wishlist-count").innerHTML = wishlist.length;

//     if (!wishlist.length) {
//     document.getElementById("wishlist-container").innerHTML =
//       "<p>Your wishlist is empty.</p>";
//        document.getElementById("MainContent").classList.add("wishlist-empty");
//      }
    
  
//     return;
//   }
  
//   // add wishlist on page
//   const btn = e.target.closest('.wishlist-btn');
//   if (!btn) return;

//   const handle = btn.dataset.handle;
//   const customerId = window.SHOPIFY_CUSTOMER_ID || null;  // injected from Liquid
//   console.log(handle,"--handle");

//   if (!handle || handle.trim() === "") return;

//   let wishlist = getWishlist();

//   // Toggle wishlist
//   if (wishlist.includes(handle)) {
//     wishlist = wishlist.filter(h => h !== handle);
//   } else {
//     wishlist.push(handle);
//   }

//   saveWishlist(wishlist);
//   updateWishlistIcons();
//   save_data_db(wishlist,customerId);
//   sendWishlistWebhook(handle);
//   //console.log(wishlist.length)
//   document.querySelector(".wishlist-count").innerHTML = wishlist.length;
  
// });
// async function save_data_db(wishlist, customerId) {
//   console.log(wishlist,"save-wishlist",wishlist.length,"customerId--",customerId);
//   if (customerId && customerId !== "null" && customerId !== "") {
//     try {
//       await fetch("https://wishlist-justherb-a3570a55df11.herokuapp.com/api/wishlist", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           actionType: wishlist.length === 0 ? "remove" : "save",
//           productHandle: wishlist.join(","),   // array → CSV string
//           customerId: String(customerId)
//         })
//       });
//        if (wishlist.length === 0) {
//         localStorage.removeItem("shopify_wishlist");
//       }else{
//         //localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
//       }

//     } catch (err) {
//       console.error("Error sending wishlist to backend:", err);
//     }
//   }
// }
// async function sava_data_storage() {
//   const customerId = window.SHOPIFY_CUSTOMER_ID || null;

//   if (customerId) {
//   try {
//     const res = await fetch(
//       'https://wishlist-justherb-a3570a55df11.herokuapp.com/api/wishlist-list?customerId=' + customerId
//     );

//     let handles = await res.json();

//     // If API returns CSV string → convert to array
//     if (typeof handles === "string") {
//       handles = handles.split(",").map(h => h.trim()).filter(Boolean);
//     }

//     // If empty → CLEAR localStorage
//     if (!handles.length) {
//       localStorage.removeItem("shopify_wishlist");
//       return;
//     }

  
//      document.querySelector(".wishlist-count").innerHTML = handles.length;

//       document.querySelectorAll('.wishlist-btn').forEach(btn => {
//         const btn_handle = btn.dataset.handle;

//         if (!btn_handle || btn_handle.trim() === "") return; // stop invalid buttons

//         btn.classList.toggle("active", handles.includes(btn_handle));
//       });

//     // Else save
//     localStorage.setItem("shopify_wishlist", JSON.stringify(handles));

//     } catch (err) {
//       console.error("Error loading wishlist:", err);
//     }
//   }else{   
//     if(JSON.parse(localStorage.getItem('shopify_wishlist'))){
//         var wishlist_lenght = JSON.parse(localStorage.getItem('shopify_wishlist')).length;
//         document.querySelector(".wishlist-count").innerHTML = wishlist_lenght;
//       }
//     updateWishlistIcons();
//   }
// }

// async function sendWishlistWebhook(productName) {
//   if (!productName) return;

//   try {
//     const response = await fetch(
//       "https://rxezc9wb37.execute-api.ap-south-1.amazonaws.com/justherbs/wishlist",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "text/plain"
//         },
//         body: JSON.stringify({
//           name: productName,
//           customerName: window.shopifyCustomer?.name || null,
//           customerEmail: window.shopifyCustomer?.email || null,
//           customerPhone: window.shopifyCustomer?.phone || null
//         })
//       }
//     );

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     const data = await response.text();
//     console.log("Wishlist webhook success:", data);

//   } catch (error) {
//     console.error("Wishlist webhook error:", error);
//   }
// }

 document.addEventListener('click', function (e) {

 const trigger = e.target.closest('.cart_value_div, .cart_open');
  if(trigger){

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');

    if (typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  const btn = e.target.closest('#copyBtn1');
  if (!btn) return;

  const codeEl = document.getElementById('couponCode1');
  if (!codeEl) return;

  const code = codeEl.innerText.trim();

  navigator.clipboard.writeText(code).then(() => {
    btn.innerText = 'Copied!';
  });
});
window.setMaxHeightQuickPrice = function () {
    const elements = document.querySelectorAll(".wrapper_lists .quick_price_wrap");
    if (!elements.length) return;

    let maxHeight = 0;

    // 🔄 Reset heights first
    elements.forEach(el => el.style.height = "auto");

    elements.forEach(el => {
      const h = el.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });

    elements.forEach(el => {
      el.style.height = maxHeight + "px";
    });
  };

window.initFlashSaleTimer = function () {
const timer = document.querySelector(".flash-timer");
  if (!timer) return;

  const endTime = new Date(timer.dataset.endTime).getTime();

  setInterval(() => {
    const now = new Date().getTime();
    const diff = endTime - now;

    if (diff <= 0) {
      timer.innerHTML = "00h : 00m : 00s";
      return;
    }

    const h = Math.floor(diff / (1000 * 60 * 60));
    const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const s = Math.floor((diff % (1000 * 60)) / 1000);

    timer.innerHTML =
      `${String(h).padStart(2, '0')}h : ${String(m).padStart(2, '0')}m : ${String(s).padStart(2, '0')}s`;
  }, 1000);
}


function equalHeightCards() {
  const productGroups = document.querySelectorAll('.contains-card--product');

  productGroups.forEach(group => {
    const cards = group.querySelectorAll('.prd_card-content .card__information');
    let maxHeight = 0;

    // Reset height first
    cards.forEach(card => {
      card.style.height = 'auto';
    });

    // Find max height within this group only
    cards.forEach(card => {
      if (card.offsetHeight > maxHeight) {
        maxHeight = card.offsetHeight;
      }
    });

    cards.forEach(card => {
      card.style.height = maxHeight + 'px';
    });
  });
}

// Load + Resize
window.addEventListener('load', equalHeightCards);
window.addEventListener('resize', equalHeightCards);



async function getCartData() {
  const res = await fetch('/cart.js');
  return await res.json();
}

function getFreebieStatus(cartValue) {
  const milestones = [
    { value: 599, name: "599" },
    { value: 799, name: "799" },
    { value: 999, name: "999" }
  ];

  let achieved = null;
  let next = null;

  for (let i = 0; i < milestones.length; i++) {
    if (cartValue >= milestones[i].value) {
      achieved = milestones[i];
    } else {
      next = milestones[i];
      break;
    }
  }

  return {
    achieved,
    difference: next ? (next.value - cartValue) : 0
  };
}

window.fireKwikCartEvent = async function () {
  try {
    const cart = await getCartData();

    const cartValue = cart.total_price / 100;
    const cartItemsCount = cart.item_count;

    // ARRAY → STRING CONVERSION
    const productIds = cart.items.map(i => i.product_id).join(",");
    const categories = cart.items.map(i => i.product_type).join(",");
    const subCategories = cart.items.map(i => i.vendor).join(",");

    const productImages = cart.items
  .map(i => i.image || i.featured_image?.url || "")
  .join(",");

  const discountPercentageRaw = document.querySelector('.discount_percentage_data')?.value || "0";
  const discountAmtRaw = document.querySelector('.total_discounts_data')?.value || "0";

  // CLEAN + CONVERT
  const discountPercentage = parseFloat(discountPercentageRaw.replace('%', '')) || 0;
  const discountAmt = parseFloat(discountAmtRaw.replace(/[^\d.]/g, '')) || 0;



    const freebieItem = document.querySelector(".freee_gift--wrapper");
   const freebieAdded = freebieItem &&
  (freebieItem.children.length > 0 || freebieItem.textContent.trim() !== "")
  ? "Yes"
  : "No";
     const freebieMRP = document.querySelector(".g-price");
     const freebieMRPValue = freebieMRP
  ? Number(freebieMRP.textContent.replace(/[^\d.]/g, ''))
  : 0;
    // Milestone
    const milestone = getFreebieStatus(cartValue);

    // Device
    const deviceType = /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop";

    const productNameFields = {};
    const productImageFields = {};

    cart.items.forEach((item, index) => {
      productNameFields[`product_name${index + 1}`] = item.product_title;
      productImageFields[`product_image_url${index + 1}`] =
    item.image || item.featured_image?.url || "";
    });

    const allProductNamesArray = cart.items.map(i => i.product_title);
  const allProductNames = allProductNamesArray.join(",");
    const displayProductNames =
    allProductNamesArray.length > 5
      ? allProductNamesArray.slice(0, 5).join(",") + "...all proudcts"
      : allProductNames;

    const attributes = {
      login_status: window.shopifyCustomer?.name ? "Yes" : "No",
      cart_value: cartValue,
      cart_items_count: cartItemsCount,

      //STRING FORMAT (IMPORTANT)
      product_ids: productIds,
      product_names:displayProductNames,
      ...productNameFields,
       ...productImageFields, 
      discount_amt: discountAmt,
      discount_amt_number:discountAmt,
      discount_percentage: discountPercentage,
      discount_percentage_number:discountPercentage,

      freebie_added: freebieAdded,
      freebie_mrp: freebieMRPValue,
      freebie_mrp_number:freebieMRPValue,

      existing_milestone: milestone.achieved ? milestone.achieved.name : "",
      freebie_difference_amount: milestone.difference,
      category: categories,
      device_type: deviceType,
      os_type: navigator.platform
    };
    console.log("Kwik Attributes:", attributes);

    KwikAnalytics.trackEvent({
      category: 'cart_event',
      name: 'Cart Page Drop',
      action: 'view',
      attributes: attributes
    });

  } catch (err) {
    console.error("Kwik Error:", err);
  }
}
// document.addEventListener("DOMContentLoaded", function () {
//   window.fireKwikCartEvent();
// });

window.updateBundleCards = async function (cart) {
  if(document.querySelectorAll('.bundle-card-li')){
  if(!cart){
     cart = await fetch('/cart.js').then(r => r.json());
  }
 

  const qty = cart.items.reduce((total, item) => {
    return item.properties?.__routine_product
      ? total + item.quantity
      : total;
  }, 0);
console.log(qty);
  // Remove active class
  document.querySelectorAll('.bundle-card-li').forEach(card => {
    card.classList.remove('active');
  });

  // Add active class
  const activeCard = document.querySelector(
    `.bundle-card-li[data-count="${qty}"]`
  );

  if (activeCard) {
    activeCard.classList.add('active');
  }

  }
}
window.removeAllMaxSaverProducts = async function(cart) {
 // const cart = await fetch('/cart.js').then(res => res.json());
 console.log("maxsaver--")
  const updates = {};

  cart.items.forEach((item) => {
    // Property se identify karo
    if (item.properties && item.properties.__maxsaver == 'true') {
      updates[item.key] = 0;
    }
  });

  if (Object.keys(updates).length) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: updates
      })
    });

    window.refreshCart();
   
  }
}